import { useMemo } from "react";

// Deterministic pseudo-random star field for hero
export default function StarField({ count = 80, className = "" }) {
  const stars = useMemo(() => {
    // Deterministic hash based on index — no mutable state
    const hash = (n) => {
      const x = Math.sin(n * 9301 + 49297) * 233280;
      return x - Math.floor(x);
    };
    return Array.from({ length: count }, (_, i) => {
      const a = hash(i + 1);
      const b = hash(i + 100);
      const c = hash(i + 999);
      const d = hash(i + 7);
      const e = hash(i + 31);
      return {
        top: a * 100,
        left: b * 100,
        delay: c * 4,
        size: d > 0.92 ? 3 : d > 0.7 ? 2 : 1,
        opacity: 0.3 + e * 0.7,
      };
    });
  }, [count]);

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      data-testid="star-field"
      aria-hidden="true"
    >
      {stars.map((s, i) => (
        <span
          key={i}
          className="star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            opacity: s.opacity,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
